<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatCustomSlaDuration } from 'dashboard/helper/customSlaTimeHelper';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  isBreached: {
    type: Boolean,
    required: true,
  },
  durationSeconds: {
    type: Number,
    default: null,
  },
});

const { t } = useI18n();

const statusText = computed(() => {
  const duration =
    props.durationSeconds != null
      ? formatCustomSlaDuration(props.durationSeconds, t)
      : null;
  const key = props.isBreached
    ? 'CUSTOM_SLA.EVENTS.BREACHED'
    : 'CUSTOM_SLA.EVENTS.MET';

  return duration ? t(`${key}_IN`, { duration }) : t(key);
});
</script>

<template>
  <div class="flex justify-between w-full">
    <span
      class="text-sm font-normal tracking-[-0.6%] min-w-[140px] truncate text-n-slate-11"
    >
      {{ label }}
    </span>
    <span
      class="text-sm font-medium text-right tabular-nums"
      :class="isBreached ? 'text-n-ruby-11' : 'text-n-teal-11'"
    >
      {{ statusText }}
    </span>
  </div>
</template>
